// extracted by mini-css-extract-plugin
export default {"tile":"HexTile_tile__umqBI","selected":"HexTile_selected__1NEEs"};